module.exports = __webpack_public_path__ + "assets/c573d9d0-0726-4b95-aeee-fb621a299563.3de9b530.svg";